
import { axios } from "@/utils/request";

// 获取对应id的文章
export const getArticle=(params)=>axios.get('/jeecg-system/common/frontend/article/active_list',{params})
// 获取文章类别
export const getAlltype=()=>axios.get('/jeecg-system/frontend/articleType/list_all')
